export default __webpack_public_path__ + "static/media/hht2_img01.12cd9ac7.png";